<template>
  <label class="create-itinerary-form-input">
    <span class="input-label-text" :class="{ 'input-label-text--required': required }">{{ label }}</span>
    <input
      v-model.trim="vModel"
      class="input-element"
      :maxlength="maxlength"
      :minlength="minlength"
      :placeholder="placeholder"
      :required="required"
      type="text"
    />
    <Transition name="fade-down">
      <span v-show="error" class="input-error">{{ error }}</span>
    </Transition>
  </label>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    maxlength: {
      type: Number,
      default: 255,
    },
    minlength: {
      type: Number,
      default: 3,
    },
    placeholder: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.create-itinerary-form-input {
  display: block;
  margin-bottom: 0;

  .input-label-text {
    display: block;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: vars.$c-dark-5b;

    &--required::after {
      content: '*';
      margin-left: 1px;
    }
  }

  .input-element {
    width: 100%;
    padding: 12px 16px;
    color: vars.$c-dark-gray;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    border-radius: 1px;
    border: 1px solid vars.$c-gray-a2;
    background-color: vars.$c-total-white;

    &::placeholder {
      color: vars.$c-gray-a2;
      font-size: 16px;
      font-weight: 400;
      line-height: normal;
    }
  }

  .input-error {
    display: block;
    margin-top: 4px;
    font-size: 14px;
    line-height: normal;
    color: vars.$c-invalid;
    letter-spacing: 1px;
  }
}
</style>
